import { Cache } from "memory-cache";
import { GroupEntity } from ".";
import { StaticStorageClient } from "../service/staticstorageclient";

// Cache
const cache = new Cache();

const dataClient = new StaticStorageClient();

export async function getCachedGroupEntity(group_id: number): Promise<GroupEntity | null> {
  let entity: any = await cache.get(group_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const group = await dataClient.get_groups_by_id(group_id);
    if (group !== null) {
      const typesInGroup = await dataClient.get_types_in_groups(group_id);
      entity = new GroupEntity(group_id, group, typesInGroup);
      cache.put(group_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
